import React, { Component } from 'react'
import Titulo from '../comum/Titulo'
import { PERFIL_ADMIN, getAdminEmpresa, getGestorEmpresa } from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import EmissaoCteOS from './EmissaoCteOS';
import { withRouter } from 'react-router-dom';
import buscarEmissoesCteOS from '../../actions/cteos/buscarEmissoesCteOS';
import selecionarEmissaoCteOs from '../../actions/cteos/selecionarEmissaoCteOs';
import transmitirEmissaoCteOs from '../../actions/cteos/transmitirEmissaoCteOs';
import cancelarCteOs from '../../actions/cteos/cancelarCteOs';
import { showSuccessMsg } from '../../util/messagesUtil';
import CabecalhoRodapeTabela from '../comum/CabecalhoRodapeTabela';
import BotoesPaginacaoCteOs from './BotoesPaginacaoCteOs';
import PaginacaoCteOs from './PaginacaoCteOs';
import determinarPaginaAtual from '../../actions/cteos/determinarPaginaAtualCteOs'
import { alterouEmpresa } from '../../actions/empresa/alterarEmpresaSelecionada';
import { alterouFiltro, alterouPagina } from '../../util/filtros';
import PainelFiltragem from './PainelFiltrosCteOs';

const ModalConfirmacaoTransmissaoCteOs = ({transmitir, limpar}) => (
    <div className="modal fade" id="modalConfirmacaoTransmissaoCteOs" tabIndex="-1" role="dialog"
         aria-labelledby="modalConfirmacao" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
                <div className="modal-body texto-centralizado">
                    <p>Deseja transmistir o Ct-e Os selecionado?</p>
                </div>
                <div className="modal-footer ">
                    <button id='cancelar' type="button" className="btn btn-outline-secondary"
                            data-dismiss="modal" 
                            onClick={() => limpar()}>Cancelar
                    </button>
                    <button type="button" className="btn btn-laranja float-left" data-dismiss="modal"
                            onClick={() => transmitir()}>Transmitir
                    </button>
                </div>
            </div>
        </div>
    </div>);

const ModalCancelamentoCteOs = ({cancelar, limpar}) => (
    <div className="modal fade" id="modalCancelamentoCteOs" tabIndex="-1" role="dialog"
         aria-labelledby="modalConfirmacao" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
                <div className="modal-body texto-centralizado">
                    <p>Deseja cancelar o Ct-e Os selecionado?</p>
                </div>
                <div className="modal-footer ">
                    <button id='cancelar' type="button" className="btn btn-outline-secondary"
                            data-dismiss="modal"
                            onClick={() => limpar()}>Não
                    </button>
                    <button type="button" className="btn btn-laranja float-left" data-dismiss="modal"
                            onClick={() => cancelar()}>Sim
                    </button>
                </div>
            </div>
        </div>
    </div>);


export const CabecalhoTabela = () => (
    <div id="header-tabela" className="lista-table d-md-block d-lg-block d-xl-block d-none d-sm-none">
        <div className="row cabecalho-desktop">
            <div className="col ml-md-2">Id</div>
            <div className="col">Data de Emissão</div>
            <div className="col">Nome Tomador</div>
            <div className="col">Descrição Serviço</div>
            <div className="col">Serie</div>
            <div className="col">Valor</div>
            <div className="col">Status CTe-os</div>
            <div className="col">Status evento Cancelamento CTe-os</div>
            <div className="col-sm-2 d-flex justify-content-center">Ações</div>
        </div>
    </div>
);

export class PainelGerenciarEmissaoCteOS extends Component {

    UNSAFE_componentWillMount() {
        this.props.determinarPaginaAtual(1)
    }

    componentDidMount() {
        this.props.selecionarEmissaoCteOs(null);
        this.buscarEmissoesCteOS();
    }

    componentDidUpdate(prevProps) {
        if (alterouEmpresa(this.props, prevProps)) {
            if (this.props.empresaSelecionada && this.props.empresaSelecionada.id) {
                this.buscarEmissoesCteOS();
            }
        }
        if (alterouFiltro(this.props, prevProps) || alterouPagina(this.props, prevProps)) {
            this.buscarEmissoesCteOS();
        }
    }

    buscarEmissoesCteOS() {
        this.props.buscarEmissoesCteOS(this.props.empresaSelecionada.id, this.props.paginaAtual, this.props.registrosPorPagina, this.props.filtrosAdicionados);
    }

    limparSelecaoEmissaoCteOs() {
        this.props.selecionarEmissaoCteOs(null);
    }

    transmitirEmissaoCteOs() {
        this.props.transmitirEmissaoCteOs(this.props.emissaoCteOsSelecionado.id, this.props.empresaSelecionada.id)
            .then(() => {
                showSuccessMsg('Foi iniciado a transmissão do ct-e os!');
                this.buscarEmissoesCteOS();
            })
    }

    cancelarCteOs() {
        this.props.cancelarCteOs(this.props.emissaoCteOsSelecionado.id, this.props.empresaSelecionada.id)
            .then(() => {
                showSuccessMsg('Foi iniciado o cancelamento do ct-e os!');
                this.buscarEmissoesCteOS();
            })
    }
    exibirBotaoNovoCteOS() {
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                getGestorEmpresa(this.props.empresaSelecionada.id),
                getAdminEmpresa(this.props.empresaSelecionada.id)]}>
                <div className="row col-md-12 mb-4">
                    <div className="row col-md-4">
                        <button className="btn btn-laranja"
                            onClick={() => {                                
                                this.props.history.push('/painel-cadastro-cte-os')
                            }}>
                            Criar Nova CT-e OS
                        </button>
                    </div>
                </div>
            </Autorizacao>)
    }

    exibirEmissoesCteOS() {
        if (this.props.emissoesCteOs.length == 0) {
            return <div>Nenhum emissão de CT-e OS.</div>;
        }

        return this.props.emissoesCteOs.map(it =>
            <EmissaoCteOS key={`emissaoCteOs-${it.id}`} cteOS={it} />);
    }

    exibirTabelaEmissaoCteOS() {
        return (<div className="col-12 conteudo-internas">
            <CabecalhoRodapeTabela OpcoesPaginacao={PaginacaoCteOs}
                                           BotoesPaginacao={BotoesPaginacaoCteOs}
                                           emissoesCteOs={this.props.emissoesCteOs}
                                           empresaSelecionada={this.props.empresaSelecionada}>
                {this.props.emissoesCteOs.length != 0 && <CabecalhoTabela />}
                <div className="lista-table">
                    {this.exibirEmissoesCteOS()}
                </div>
            </CabecalhoRodapeTabela>
        </div>
        )
    }

    render() {
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                getGestorEmpresa(this.props.empresaSelecionada.id),
                getAdminEmpresa(this.props.empresaSelecionada.id)]}>
                <div>
                    <div className='col-md-12'>
                        <Titulo texto="Painel Emissão CT-e OS" urlRetorno="/menu-cteos" />
                    </div>
                    <div className="col-12 filtro-busca">
                        <PainelFiltragem/>
                    </div>
                    {this.exibirBotaoNovoCteOS()}
                    {this.exibirTabelaEmissaoCteOS()}
                </div>
                <ModalConfirmacaoTransmissaoCteOs transmitir={this.transmitirEmissaoCteOs.bind(this)} limpar={this.limparSelecaoEmissaoCteOs.bind(this)} />
                <ModalCancelamentoCteOs cancelar={this.cancelarCteOs.bind(this)} limpar={this.limparSelecaoEmissaoCteOs.bind(this)} />
            </Autorizacao>
        )
    }
}


export const mapStateToProps = state => ({
    empresaSelecionada: state.empresaSelecionada,
    emissoesCteOs: state.emissoesCteOs.emissaoCteOS,
    emissaoCteOsSelecionado: state.emissaoCteOsSelecionado,
    paginaAtual: state.paginaAtualCteOs,
    registrosPorPagina: state.registrosPorPaginalCteOs,
    filtrosAdicionados: state.filtrosAdicionadosCteOs
})

export default withRouter(connect(mapStateToProps,
    {
        buscarEmissoesCteOS,
        selecionarEmissaoCteOs,
        transmitirEmissaoCteOs,
        cancelarCteOs,
        determinarPaginaAtual
    })(reduxForm({
        form: 'formularioPainelCteOS'
    })(PainelGerenciarEmissaoCteOS)))